import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router";

import { telemetryService } from "../../../services/TelemetryService";
import OutageNoteDialog from "./OutageNoteDialog";

import moment from "moment";
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import CreateIcon from "@mui/icons-material/Create";

const classes = {
    container: {
        width: "90%",
        marginBottom: "3rem",
    },
    title: {
        fontWeight: "700",
        marginBottom: "1.5rem",
        fontSize: "1.2rem",
    },
    editIcon: {
        "&:hover": {
            cursor: "pointer",
            color: "#1976d2",
        },
    },
};

export default function DeviceStatusHistory({ data }) {
    const { id } = useParams();
    const [openStatus, setOpenStatus] = useState(false);
    const [note, setNote] = useState("");
    const [noteDttm, setNoteDttm] = useState(null);
    const [updatedNotes, setUpdatedNotes] = useState({});

    const handleDialogOpen = useCallback((bool, note, dttmLastReport) => {
        setNoteDttm(dttmLastReport);
        setNote(note);
        setOpenStatus(bool);
    }, []);

    const handleCreateNote = async (note) => {
        if (id) {
            try {
                await telemetryService.upsertDeviceStatusHistory(id, noteDttm, note);

                setUpdatedNotes({ ...updatedNotes, ...{ [noteDttm]: note } });
            } catch (err) {
                console.log("Error updating note.", err);
            }
        }
    };

    const updateNotes = useCallback((data) => {
        setUpdatedNotes((updatedNotes) => Object.assign(updatedNotes, { [data.dttm_last_report]: data.note }));
    }, []);

    useEffect(() => {
        if (data?.length) {
            data.forEach((d) => {
                updateNotes(d);
            });
        }
    }, [data, updateNotes]);

    return (
        <Box component="div" sx={classes.container}>
            <Box component="div" sx={classes.title}>Device Status History</Box>
            <TableContainer component={Paper}>
                <Table aria-label="simple table" stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">Device ID</TableCell>
                            <TableCell align="center">Last Repot Dttm (UTC)</TableCell>
                            <TableCell align="center">Status</TableCell>
                            <TableCell align="center">Note</TableCell>
                            <TableCell align="center"></TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {data?.length
                            ? data.map((d) => {
                                  let { edge_device_id, dttm_last_report, status, note } = d;
                                  let utcDateTime = moment(dttm_last_report).format("MMMM DD, YYYY HH:mm:ss");
                                  let outageNote = updatedNotes[dttm_last_report] ?? note;

                                  return (
                                      <TableRow key={dttm_last_report}>
                                          <TableCell align="center">{edge_device_id}</TableCell>
                                          <TableCell align="center">{utcDateTime}</TableCell>
                                          <TableCell align="center">{status}</TableCell>
                                          <TableCell align="center">{outageNote}</TableCell>
                                          <TableCell align="center">
                                              <Tooltip title="Edit Note">
                                                  <CreateIcon
                                                      sx={classes.editIcon}
                                                      onClick={(e) =>
                                                          handleDialogOpen(true, outageNote, dttm_last_report)
                                                      }
                                                  />
                                              </Tooltip>
                                          </TableCell>
                                      </TableRow>
                                  );
                              })
                            : null}
                    </TableBody>
                </Table>
            </TableContainer>

            <OutageNoteDialog
                type={"history"}
                openStatus={openStatus}
                handleDialogOpen={handleDialogOpen}
                handleCreateNote={handleCreateNote}
                deviceId={id}
                note={note}
                noteDttm={noteDttm}
            />
        </Box>
    );
}
